import React from "react";
import "./Nanotechnology.css";
import ayurvedaImg from "../assets/ayurveda1.jpg";
import nanoImg from "../assets/nano.jpg";


import uvImg from "../assets/uv.jpg";
import oilImg from "../assets/oil.jpg";
import repairImg from "../assets/repair.jpg";
import finishImg from "../assets/finish.jpg";

import bgImage from "../assets/backgroundimage.jpg";

import processImg from "../assets/process.png";


import nanoImg1 from "../assets/nano1.jpg";
import nanoImg2 from "../assets/nano2.jpg";
import nanoImg3 from "../assets/nano3.jpg";
import nanoImg4 from "../assets/nano4.jpg";

import nutraImg from "../assets/Rnutra.jpg";


import icon1 from "../assets/icon1.png"; // 👈 apni image

import bioBg from "../assets/your-image.jpg"; // 👈 apna image name


import { FaChartLine, FaShieldAlt, FaInfinity } from "react-icons/fa";


// ✅ yaha change karo
import nanoCircleImg from "../assets/nano-circles.png";



function Nanotechnology() {
  return (
    <div className="nano-page"
     style={{ backgroundImage: `url(${bgImage})` }}
    >

      {/* 1️⃣ Hero Section */}
      <section className="nano-hero">
        <h1>Nanotechnology</h1>
        <p>Enhancing classical wisdom through molecular precision</p>
      </section>




      
<section className="mx-process-section">

  <div className="mx-process-container">

    {/* Heading */}
    <h2 className="mx-process-title">
      Our Molecular Innovation Process
    </h2>

    {/* Center Image */}
    <div className="mx-process-image">
      <img src={processImg} alt="process" />
    </div>

    {/* Text */}
    {/* <div className="mx-process-text">
      <p>
        At ManuX, our molecular innovation process combines advanced
        scientific methods with precision formulation. Each stage is
        carefully engineered to ensure stability, absorption, and
        predictable performance.
      </p>
    </div> */}

  </div>

  {/* Bottom Highlight Bar */}
  <div className="mx-process-bar">
    <p>
      <strong>The ManuX Result:</strong> 
      <span> ✅ Improved Consistency </span> |
      <span> ✅ Reduced Wastage </span> |
      <span> ✅ Predictable Outcomes </span>
    </p>
  </div>

</section>





{/* 2️⃣ Introduction Section */}
<section className="ayurveda-section">
{/* 
    <div
    className="ayurveda-image"
   // style={{ backgroundImage: `url(${ayurvedaImg})` }}
  >
  </div> */}
  {/* <div className="ayurveda-wrapper"> */}

    {/* Left Content */}



<div className="bio-section"
style={{ backgroundImage: `url(${bioBg})` }}
>

  <h2 className="bio-title">BIOLOGICAL ADVANTAGES</h2>

  <p className="bio-desc">
    Nano-scale ayurvedic systems are designed to align with natural biological pathways.<br/>
    By reducing particle size and optimizing delivery behavior, they allow actives to interact<br/>
    more efficiently with skin, hair follicles, tissues, and metabolic systems.
  </p>

  {/* CARD 1 */}
  <div className="bio-box">
    <div className="bio-icon">
      <FaChartLine />
    </div>
    <div>
      <h3>ENHANCED EFFICACY</h3>
      <p>(Maximizes results at lower concentrations.)</p>
    </div>
  </div>

  {/* CARD 2 */}
  <div className="bio-box">
    <div className="bio-icon">
      <FaShieldAlt />
    </div>
    <div>
      <h3>IMPROVED TOLERABILITY</h3>
      <p>(Gentle on tissues and systems.)</p>
    </div>
  </div>

  {/* CARD 3 */}
  <div className="bio-box">
    <div className="bio-icon">
      <FaInfinity />
    </div>
    <div>
      <h3>LONG-TERM COMPATIBILITY</h3>
      <p>(Harmonious interaction for lasting health.)</p>
    </div>
  </div>

</div>




     {/* <div className="ayurveda-text">
      <span className="ayurveda-tag">Nano Ayurveda</span>
      <h2>Revolutionizing Ayurveda</h2>

      <p>
        At <strong>ManuX NanoBioCeuticals</strong>, we seamlessly blend
        the timeless wisdom of Ayurveda with advanced nanotechnology,
        crafting transformative skincare solutions that deliver
        remarkable results.
      </p>

      <p>
        By reducing active ingredients to nanoscale particles, we enhance
        bioavailability, ensuring deep penetration and optimal rejuvenation.
      </p>

      <ul>
        <li>✔ Enhanced Bioavailability</li>
        <li>✔ Deep Dermal Penetration</li>
        <li>✔ Faster & Visible Results</li>
      </ul>
    </div>  */}

    {/* Right Image */}
     {/* <div className="ayurveda-image">
      <img src={ayurvedaImg} alt="Ayurveda Research" className="hero-image" />
    </div>  */}

{/* 
  </div> */}
</section>







      {/* 3️⃣ Why Nano Grid */}
    {/* <section className="nano-dark1">
  <h2 className="section-title">Why Nanotechnology?</h2>

  <div className="nano-grid1">
    <div className="nano-card2">
      <h3>Enhanced Absorption</h3>
      <p>Deep penetration into skin layers for superior nourishment.</p>
    </div>

    <div className="nano-card2">
      <h3>Increased Potency</h3>
      <p>Amplified effectiveness with minimal application.</p>
    </div>

    <div className="nano-card2">
      <h3>Rapid Results</h3>
      <p>Visible transformation in a shorter time span.</p>
    </div>

    <div className="nano-card2">
      <h3>Superior Stability</h3>
      <p>Improved formulation longevity and efficacy.</p>
    </div>
  </div>
</section> */}




 <section className="nano-circle-section">

  <div className="nano-circle-container">

    <h2 className="nano-circle-heading">
      Our Specialized Care Categories
    </h2>

    <p className="nano-circle-subtext">
      Advanced nano-enabled formulations designed for diverse care needs,
      ensuring safety, performance, and targeted effectiveness.
    </p>

    <div className="nano-circle-image-wrapper">
  <img
     src={nanoCircleImg}   // 👈 updated name

    alt="Nano Categories"
    className="nano-circle-image"
  />
</div>
  </div>

</section> 





      {/* 4️⃣ Science Section */}
  {/* <section className="science-section">

  <div className="science-container">

    {/* LEFT CONTENT */}
   {/*} <div className="science-content">
      <h2>The Science Behind Nano Delivery</h2>

      <p>
        Nanotechnology encapsulates Ayurvedic phytochemicals into
        semi-soluble nano carriers that activate upon application.
        This ensures precise, targeted release into deeper dermal layers.
      </p>
    </div>

    {/* RIGHT IMAGE */}
   {/*} <div className="science-image">
      <img src={nanoImg } alt="Nano Technology" />
    </div>

  </div>

</section> */}



      {/* 5️⃣ Skin Benefits Section */}
      {/* <section className="nano-light">
  <h2 className="section-title">Comprehensive Skin Solutions</h2>

  <div className="nano-grid1">

    <div className="card1" style={{ backgroundImage: `url(${uvImg})` }}>
      <div className="card1-overlay">
        <h3>UV & Pollution Protection</h3>
        <p>Acts as a natural barrier against environmental damage.</p>
      </div>
    </div>

    <div className="card1" style={{ backgroundImage: `url(${oilImg})` }}>
      <div className="card1-overlay">
        <h3>Oil & Sebum Control</h3>
        <p>Balances excessive sebum production effectively.</p>
      </div>
    </div>

    <div className="card1" style={{ backgroundImage: `url(${repairImg})` }}>
      <div className="card1-overlay">
        <h3>Fine Line Repair</h3>
        <p>Targets wrinkles and periorbital areas with precision.</p>
      </div>
    </div>

    <div className="card1" style={{ backgroundImage: `url(${finishImg})` }}>
      <div className="card1-overlay">
        <h3>Long-Lasting Finish</h3>
        <p>Provides refined, smooth and radiant skin texture.</p>
      </div>
    </div>

  </div>
</section> */}



    {/* 6️⃣ Pure Formulation Section */}
<section className="nano-dark">
  <div className="nano-container">
    <h2>100% Plant-Based Nano Herbal Extracts</h2>
    <p>
      Our formulations contain no chemicals, no alcohol, and no harsh
      ingredients. Every product is crafted from pure plant materials.
    </p>

    <div className="nano-features">
      <div className="nano-box">No Chemicals</div>
      <div className="nano-box">No Alcohol</div>
      <div className="nano-box">100% Plant-Based</div>
    </div>
  </div>
</section>



     {/* 7️⃣ Expertise Section */}
<section className="nano-expertise-section">
  <h2 className="section-title">Our Nano Expertise</h2>

  <div className="nano-expertise-grid">

    <div
      className="nano-card"
      style={{ backgroundImage: `url(${nanoImg1})` }}
    >
      <h3>Anti-Aging Liposomes</h3>
    </div>

    <div
      className="nano-card"
     // style={{ backgroundImage: `url(${nanoImg2})` }}
        style={{ backgroundImage: `url(${nanoImg3})` }}
    >
      <h3>Anti-Acne Nano Therapy</h3>
    </div>

    <div
      className="nano-card"
     // style={{ backgroundImage: `url(${nanoImg3})` }}

       style={{ backgroundImage: `url(${nanoImg2})` }}

    >
      <h3>Under-Eye Repair</h3>
    </div>

    <div
      className="nano-card"
      style={{ backgroundImage: `url(${nanoImg4})` }}
    >
      <h3>Skin Radiance & Hair Growth</h3>
    </div>

  </div>
          </section>










       <section className="mx-safety-section1">

   <div className="mx-safety-container1"> 

    {/* LEFT SIDE - IMAGE */}
    <div className="mx-safety-left1">
      <img src={icon1} alt="safety" />
    </div>

    {/* RIGHT SIDE - CONTENT */}
    <div className="mx-safety-right1">

      <h2 className="mx-safety-title1">Safety and Integrity</h2>

      <p className="mx-safety-text1">
        At ManuX, nanotechnology is applied responsibly. We prioritize 
        biocompatible materials, controlled processing, and rigorous safety 
        evaluation to ensure that nano systems remain stable, non-aggressive, 
        and suitable for long-term use.
      </p>

      <p className="mx-safety-text1">
        Our approach respects the philosophical foundations of Ayurveda 
        while meeting modern expectations for safety, reproducibility, 
        and scientific validation.
      </p>

      <div className="mx-safety-points1">
        <div className="mx-point1">✔ Biocompatible Materials</div>
        <div className="mx-point1">✔ Rigorous Evaluation</div>
        <div className="mx-point1">✔ Scientific Validation</div>
      </div>

    </div>

     </div> 

</section>











      {/* 8️⃣ CTA Section */}
      {/* <section className="nano-cta">
        <h2>Discover the Power of Nano Ayurveda</h2>
        <p>
          Experience the difference with ManuX NanoBioCeuticals and redefine
          luxury through innovation.
        </p>
        <button className="btn">Explore Products</button>
      </section> */}

    </div>
  );
}

export default Nanotechnology;
